import { combineActions, handleActions } from 'redux-actions'
import { fromJS } from 'immutable'

import { updateStoryApiRequest } from 'store/entities/feed/actions'
import { cloneProTrack } from 'store/entities/protracks/actions'
import { postOrganizationChildren } from 'store/entities/organizationSettings/actions'
import { deleteImageFromGallery } from 'store/entities/gallery/actions'

import { modal } from './actions'

export const initialState = fromJS({
  isOpen: false,
  closeTimeoutMS: 400,
  contentLabel: 'Modal',
  children: null,
  restProps: {},
})

const handleModalShow = (state, { payload: { children, restProps } }) => {
  return state
    .set('isOpen', true)
    .set('children', children)
    .set('restProps', restProps)
}

const handleModalHide = state => {
  return state.set('isOpen', false)
}

const handleUpdateStoryApiRequestSuccess = state => {
  return state.set('isOpen', false)
}

export default handleActions(
  {
    [modal.show]: handleModalShow,
    [combineActions(
      modal.hide,
      cloneProTrack.success,
      postOrganizationChildren.success,
      deleteImageFromGallery.success
    )]: handleModalHide,
    [updateStoryApiRequest.success]: handleUpdateStoryApiRequestSuccess,
  },
  initialState
)
